<!--
 * @Author: your name
 * @Date: 2021-05-16 03:16:24
 * @LastEditors: 聪Cong
 * @LastEditTime: 2022-07-09 22:25:15
 * @FilePath: /卫星/weixing/src/page/weixing.vue
-->



<template>
  <div class="weixing">
    <Layout
      style="background: rgba(255, 255, 255, 0); height: 100%; width: 100%"
    >
      <Header style="background: rgba(255, 255, 255, 0); height: 10%"></Header>
      <Content>
        <Row class="Row" type="flex" justify="center">
          <Col flex="auto"> </Col>
          <Col flex="300px">
            <Card style="background: rgba(255, 255, 255, 0.6)">
              <icon></icon>
              <layout style="background: rgba(255, 255, 255, 0)">
                <Content>
                  <Form label-position="right" :label-width="100">
                    <p class="pbt">
                      <svg
                        t="1621133470464"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="8709"
                        width="30"
                        height="30"
                      >
                        <path
                          d="M740.9 315.9l37.8-37.8c8 3.3 16.9 5.2 26.1 5.2 37.6 0 68.2-30.6 68.2-68.2s-30.6-68.2-68.2-68.2-68.2 30.6-68.2 68.2c0 10.1 2.2 19.7 6.2 28.3l-35.5 35.5c-1.3-1.3-2.6-2.7-4-4-68.6-68.6-148.3-118.4-224.4-140.2-38.4-11-74.1-14.4-106.1-10.1-35.1 4.7-64.3 18.4-86.6 40.8s-36.1 51.5-40.8 86.6c-1.7 12.5-2.2 25.6-1.5 39.2-8.9 31.8-13.5 64.7-13.5 98.1 0 52.6 11 103.2 32.7 150.5l-76.7 227.6-34 101c-2.6 7.6-1.3 16 3.4 22.6 4.7 6.5 12.3 10.4 20.3 10.4h266.6c0.7 0 1.4 0 2-0.1 0.3 0 0.5 0 0.8-0.1 0.1 0 0.3 0 0.4-0.1 0.3 0 0.6-0.1 1-0.1 0.2 0 0.3-0.1 0.5-0.1 0.3-0.1 0.6-0.1 0.9-0.2 0.2 0 0.4-0.1 0.6-0.2 0.2-0.1 0.5-0.1 0.7-0.2 0.3-0.1 0.5-0.2 0.8-0.2 0.2-0.1 0.4-0.1 0.6-0.2l0.9-0.3c0.1-0.1 0.3-0.1 0.4-0.2 0.3-0.1 0.6-0.3 0.9-0.4 0.1-0.1 0.2-0.1 0.3-0.2 0.3-0.2 0.6-0.3 1-0.5 0.1 0 0.2-0.1 0.3-0.1 0.3-0.2 0.6-0.4 1-0.6 0.1-0.1 0.2-0.1 0.2-0.2l0.9-0.6c0.1-0.1 0.2-0.1 0.3-0.2l0.9-0.6c0.1-0.1 0.2-0.1 0.3-0.2 0.3-0.2 0.5-0.4 0.8-0.6l0.3-0.3c0.2-0.2 0.5-0.4 0.7-0.6l0.4-0.4 0.6-0.6c0.2-0.2 0.3-0.4 0.5-0.5 0.2-0.2 0.3-0.4 0.5-0.5l0.1-0.1c0.2-0.2 0.3-0.4 0.4-0.6 0.1-0.1 0.2-0.2 0.3-0.4 0 0 0-0.1 0.1-0.1 0.1-0.1 0.2-0.3 0.3-0.4 0.2-0.2 0.3-0.5 0.5-0.7 0.1-0.1 0.2-0.3 0.3-0.4 0.2-0.3 0.3-0.5 0.5-0.8 0.1-0.1 0.1-0.2 0.2-0.3 0.2-0.3 0.3-0.6 0.5-0.9 0-0.1 0.1-0.2 0.1-0.3 0.2-0.3 0.3-0.7 0.5-1 0-0.1 0-0.1 0.1-0.2 0.2-0.4 0.3-0.8 0.5-1.2 0.6-1.7 1.1-3.5 1.3-5.3 0.1-0.4 0.1-0.8 0.1-1.3v-0.3-1-0.4-0.9-0.4c0-0.3 0-0.6-0.1-0.9v-0.4c0-0.4-0.1-0.7-0.1-1.1v-0.2c-0.1-0.4-0.1-0.9-0.2-1.3v-0.1l-32.5-156.1c49 23.8 103.1 36.2 158 36.2 37.4 0 74.2-5.7 109.5-16.9 8.2-0.1 16.3-0.7 24.1-1.7 35.1-4.7 64.3-18.4 86.6-40.8s36.1-51.5 40.8-86.6c4.3-32 0.9-67.7-10.1-106.1-18.2-61.4-54-125.1-103.1-183.4z m63.9-119.1c10.1 0 18.2 8.2 18.2 18.2s-8.2 18.2-18.2 18.2-18.2-8.2-18.2-18.2 8.1-18.2 18.2-18.2zM364.5 670.5L266 687.3l30.2-89.8c19.3 27.3 42.3 52 68.3 73z m40.3 146.9l-113.6-83.7 92.9-15.8 20.7 99.5z m-163-58l124.7 91.9H210.8l31-91.9zM413 644.6c-0.1-0.1-0.3-0.2-0.4-0.3-42.5-30-77-70.4-100-116.9-0.1-0.1-0.1-0.3-0.2-0.4-15.6-31.5-25.5-64.9-29.7-99.5 26.5 53.7 65.1 107 113 154.8 50.5 50.5 106.9 90.7 163.6 117.2-43.6-4.7-85.9-18.4-123.8-40.5-7.7-4.4-15.3-9.3-22.5-14.4z m391-45.9c-3.2 24-12.2 43.5-26.6 57.9s-33.9 23.3-57.9 26.6c-25.1 3.4-54 0.5-85.7-8.7C565.7 655 493.7 609.7 431 547S323 412.3 303.5 344.2c-5.2-18-8.3-35-9.5-51 0-0.7-0.1-1.3-0.1-2-0.7-11.5-0.4-22.4 1-32.7 3.2-24 12.2-43.5 26.6-57.9s33.9-23.3 57.9-26.6c6.8-0.9 13.8-1.4 21-1.4 19.8 0 41.4 3.3 64.6 10 68.1 19.6 140.1 64.8 202.8 127.5 1.3 1.3 2.6 2.7 4 4L493.6 492.4c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3 6.4 0 12.8-2.4 17.7-7.3l176.4-176.4c43.2 52 74.6 108.1 90 161.7 9.1 31.6 12 60.5 8.6 85.6z"
                          p-id="8710"
                        ></path>
                      </svg>
                      地面站信息
                    </p>
                    <!-- <Form label="Title name">
                      高度
                      <Input
                        v-model="dimianzhan.gaodu"
                        class="custom"
                        placeholder="高度"
                        style="width: auto"
                        readonly
                      />
                    </Form> -->
                    <Form label="Title name">
                      纬度
                      <Input
                        v-model="dimianzhan.weidu"
                        class="custom"
                        placeholder="纬度"
                        style="width: auto"
                        readonly
                      />
                    </Form>
                    <Form label="Title name">
                      经度
                      <Input
                        v-model="dimianzhan.jingdu"
                        class="custom"
                        placeholder="经度"
                        style="width: auto"
                        readonly
                      ></Input>
                    </Form>
                    <br />
                    <p class="pbt">
                      <svg
                        t="1621135014213"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="8841"
                        width="30"
                        height="30"
                      >
                        <path
                          d="M441.6 793.6c12.8-12.8 12.8-38.4 0-51.2l-64-64 32-38.4 64 64c12.8 12.8 38.4 12.8 51.2 0l147.2-147.2c12.8-12.8 12.8-38.4 0-51.2l-64-64 32-32v-6.4l64 64c12.8 12.8 38.4 12.8 51.2 0l179.2-179.2c12.8-12.8 12.8-38.4 0-51.2L755.2 57.6c-12.8-12.8-38.4-12.8-51.2 0L531.2 236.8c-19.2 12.8-19.2 38.4 0 51.2l64 64-32 32-224-217.6c-12.8-12.8-38.4-12.8-51.2 0L140.8 313.6c-12.8 12.8-12.8 38.4 0 51.2l217.6 217.6-32 38.4v6.4l-64-64c-12.8-12.8-38.4-12.8-51.2 0L32 742.4c-12.8 12.8-12.8 38.4 0 51.2l179.2 179.2c12.8 12.8 38.4 12.8 51.2 0l179.2-179.2z m294.4-659.2l128 128L742.4 384l-128-128 121.6-121.6zM217.6 339.2l96-96 64 64-96 96-64-64z m96 96l96-96 192 192-102.4 96-185.6-192z m-76.8 454.4l-128-128 121.6-128 128 128-121.6 128z m710.4-396.8l-25.6-44.8c-6.4-12.8-19.2-12.8-32-6.4s-12.8 19.2-6.4 32c32 51.2 51.2 108.8 51.2 172.8 0 44.8-6.4 83.2-25.6 121.6-32 76.8-96 140.8-172.8 172.8-38.4 12.8-76.8 25.6-121.6 25.6s-89.6-12.8-134.4-32l-38.4-19.2c-12.8-6.4-25.6-6.4-32 6.4-6.4 12.8-6.4 25.6 6.4 32 19.2 6.4 32 12.8 51.2 19.2 51.2 19.2 102.4 32 153.6 32 51.2 0 96-12.8 140.8-25.6 89.6-38.4 160-108.8 198.4-198.4 19.2-44.8 25.6-89.6 25.6-140.8-6.4-44.8-19.2-102.4-38.4-147.2z m-211.2 268.8c-12.8 12.8-32 25.6-51.2 38.4-38.4 19.2-83.2 12.8-128 0-12.8-6.4-25.6 0-32 12.8-6.4 12.8 0 25.6 12.8 32 6.4 0 12.8 6.4 19.2 6.4 44.8 12.8 96 12.8 140.8-6.4 25.6-12.8 51.2-25.6 70.4-44.8 19.2-19.2 38.4-44.8 44.8-70.4 12.8-25.6 19.2-51.2 19.2-76.8v-19.2c0-12.8-6.4-25.6-6.4-38.4 0-6.4-6.4-12.8-6.4-19.2-6.4-12.8-19.2-19.2-32-12.8-19.2-6.4-25.6 6.4-19.2 19.2 6.4 12.8 12.8 32 12.8 44.8v19.2c0 19.2-6.4 44.8-12.8 64-6.4 19.2-19.2 38.4-32 51.2z"
                          fill=""
                          p-id="8842"
                        ></path>
                      </svg>
                      卫星信息
                    </p>
                    <!-- <Form label="Title name">
                      纬度
                      <Input
                        v-model="weixing.weidu"
                        class="custom"
                        placeholder="纬度"
                        style="width: auto"
                      ></Input>
                    </Form> -->
                    <Form label="Title name">
                      经度
                      <Input
                        v-model="weixing.jingdu"
                        class="custom"
                        placeholder="在这里输入卫星的经度"
                        style="width: auto"
                        clearable
                        autofocus
                      ></Input>
                    </Form>
                    <Button
                      v-on:click="CalculateAZ"
                      style="margin-top: 20px"
                      type="primary"
                      shape="circle"
                      >计算</Button
                    >
                  </Form>
                </Content>
              </layout>
            </Card>
          </Col>
          <Col flex="auto"> </Col>
        </Row>

        <Row style="margin-top: 20px" class="Row" type="flex" justify="center">
          <Col flex="auto"> </Col>
          <Col flex="300px">
            <Card style="background: rgba(255, 255, 255, 0.6); height: 90px">
              <layout style="background: rgba(255, 255, 255, 0)">
                <Content>
                  <p>
                    我的方位角: {{ tuoluuoyi.fangwei }} 方位角:{{
                      jiaodu.fangwei
                    }}
                  </p>
                  <p>
                    我的俯仰角: {{ tuoluuoyi.fuyan }} 俯仰角: {{ jiaodu.fuyan }}
                  </p>
                  <p>
                    我的极化角: {{ tuoluuoyi.jihua }} 极化角: {{ jiaodu.jihua }}
                  </p>
                  <!-- <p>
                    方位角:{{ jiaodu.fangwei }}
                  </p>
                  <p>
                    俯仰角: {{ jiaodu.fuyan }}
                  </p>
                  <p>
                    极化角: {{ jiaodu.jihua }}
                  </p> -->
                </Content>
              </layout>
            </Card>
          </Col>
          <Col flex="auto"> </Col>
        </Row>
      </Content>
      <Footer
        style="
          color: #000;
          background: rgba(255, 255, 255, 0);
          text-align: center;
          padding-top: 5px;
        "
      >
        <p>卫星角度计算器 ©粤ICP备666号</p>
        <p>开发者:聪Cong</p>
      </Footer>
    </Layout>
  </div>
</template>


<script>
import icon from "../components/icon.vue";
export default {
  name: "weixing",
  components: {
    icon,
  },
  data() {
    return {
      dimianzhan: {
        //地面站
        gaodu: "0", //高度
        weidu: "", //纬度
        jingdu: "", //经度
      },
      weixing: {
        //卫星
        weidu: "0", //纬度
        jingdu: "", //经度
      },
      jiaodu: {
        //输出角度
        fangwei: "未计算", //方位
        fuyan: "未计算", //俯仰
        jihua: "未计算", //极化
        juli: "未计算", //最大距离
      },
      tuoluuoyi: {
        fangwei: "0", //方位
        fuyan: "0", //俯仰
        jihua: "0", //极化
      },
    };
  },
  methods: {
    //定义方法的位置
    getLocation() {
      //获取地理位置函数
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError
        );
      } else {
        this.background("error", "该浏览器不支持定位功能");
      }
    },
    showPosition(position) {
      //获取经纬度（回调函数）
      this.background(
        "success",
        "获取位置成功" +
          "\n纬度：" +
          position.coords.latitude +
          "\n经度：" +
          position.coords.longitude
      );

      this.dimianzhan.jingdu = position.coords.longitude;
      this.dimianzhan.weidu = position.coords.latitude;
    },
    showError(error) {
      //获取经纬度失败（回调函数）
      switch (error.code) {
        case error.PERMISSION_DENIED:
          this.background("error", "用户拒绝对获取地理位置的请求");
          break;
        case error.POSITION_UNAVAILABLE:
          this.background("error", "位置信息是不可用的");
          break;
        case error.TIMEOUT:
          this.background("error", "请求用户地理位置超时");
          break;
        case error.UNKNOWN_ERROR:
          this.background("error", "未知错误");
          break;
      }
    },
    background(type, str) {
      //提示框
      this.$Message[type]({
        background: true,
        content: str,
      });
    },
    CalculateAZ() {
      //计算方位、俯仰、极化
      var DTOR,
        RTOD,
        A,
        // B,
        F,
        RSAT,
        ESHEIGHT,
        ESLAT,
        ESLONG,
        SATLAT,
        SATLONG,
        XS,
        YS,
        ZS,
        EE,
        BETA,
        RHO,
        EL;
      var TXS,
        TYS,
        TZS,
        DIST,
        AZ,
        XS2,
        YS2,
        ZS2,
        TXS2,
        TYS2,
        TZS2,
        DIST2,
        RANGE;

      DTOR = Math.PI / 180;
      RTOD = 180 / Math.PI;
      A = 6378.388;
      //   B = 6356.912;
      F = 1 / 297;
      RSAT = Math.pow(6028.82 * (24 * 60 - 4), 2 / 3);
      //   this.Check(window.document.Form.ESH, "0");
      //   this.Check(window.document.Form.ESLA, "34.25");
      //   this.Check(window.document.Form.ESLO, "108.88");
      //   this.Check(window.document.Form.SATLA, "0");
      //   this.Check(window.document.Form.SATLO, "92.2");
      this.gyroscope(); //启动陀螺仪

      if (
        this.dimianzhan.gaodu === "" ||
        this.dimianzhan.weidu === "" ||
        this.dimianzhan.jingdu === "" ||
        this.weixing.weidu === "" ||
        this.weixing.jingdu === ""
      ) {
        this.background("error", "请输入数值");
        return 0;
      }

      ESHEIGHT = Number(this.dimianzhan.gaodu); //地面站高度
      ESLAT = Number(this.dimianzhan.weidu); //地面站纬度
      ESLONG = Number(this.dimianzhan.jingdu); //地面站经度
      SATLAT = Number(this.weixing.weidu); //卫星纬度
      SATLONG = Number(this.weixing.jingdu); //卫星经度
      if (
        isNaN(ESHEIGHT) ||
        isNaN(ESLAT) ||
        isNaN(ESLONG) ||
        isNaN(SATLAT) ||
        isNaN(SATLONG)
      ) {
        this.background("error", "输入的数不是数值");
        return 0;
      }
      console.log(ESHEIGHT, ESLAT, ESLONG, SATLAT, SATLONG);
      XS = RSAT * Math.cos(DTOR * SATLAT) * Math.cos(DTOR * SATLONG);
      XS2 = RSAT * Math.cos(-SATLAT * DTOR) * Math.cos(SATLONG * DTOR);
      YS = RSAT * Math.cos(DTOR * SATLAT) * Math.sin(DTOR * SATLONG);
      YS2 = RSAT * Math.cos(-SATLAT * DTOR) * Math.sin(SATLONG * DTOR);
      ZS = RSAT * Math.sin(DTOR * SATLAT);
      ZS2 = -RSAT * Math.sin(DTOR * SATLAT);
      EE = 2 * F - Math.pow(F, 2);
      BETA = Math.atan((1 - EE) * Math.tan(ESLAT * DTOR));
      RHO =
        (A * (1 - F)) /
        Math.sqrt(
          1 - (2 - F) * F * Math.cos(ESLAT * DTOR) * Math.cos(ESLAT * DTOR)
        );
      TXS =
        (XS * Math.cos(ESLONG * DTOR) +
          YS * Math.sin(ESLONG * DTOR) -
          RHO * Math.cos(BETA)) *
          Math.sin(ESLAT * DTOR) -
        (ZS - RHO * Math.sin(BETA)) * Math.cos(ESLAT * DTOR);
      TXS2 =
        (XS2 * Math.cos(ESLONG * DTOR) +
          YS2 * Math.sin(ESLONG * DTOR) -
          RHO * Math.cos(BETA)) *
          Math.sin(ESLAT * DTOR) -
        (ZS2 - RHO * Math.sin(BETA)) * Math.cos(ESLAT * DTOR);
      TYS = -XS * Math.sin(ESLONG * DTOR) + YS * Math.cos(ESLONG * DTOR);
      TYS2 = -XS2 * Math.sin(ESLONG * DTOR) + YS2 * Math.cos(ESLONG * DTOR);
      TZS =
        (XS * Math.cos(ESLONG * DTOR) +
          YS * Math.sin(ESLONG * DTOR) -
          RHO * Math.cos(BETA)) *
          Math.cos(ESLAT * DTOR) +
        (ZS - RHO * Math.sin(BETA)) * Math.sin(ESLAT * DTOR) -
        ESHEIGHT / 1000;
      TZS2 =
        (XS2 * Math.cos(ESLONG * DTOR) +
          YS2 * Math.sin(ESLONG * DTOR) -
          RHO * Math.cos(BETA)) *
          Math.cos(ESLAT * DTOR) +
        (ZS2 - RHO * Math.sin(BETA)) * Math.sin(ESLAT * DTOR) -
        ESHEIGHT / 1000;
      DIST = Math.sqrt(TXS * TXS + TYS * TYS + TZS * TZS);
      DIST2 = Math.sqrt(TXS2 * TXS2 + TYS2 * TYS2 + TZS2 * TZS2);
      AZ = 180 - RTOD * this.ATAN2(TXS, TYS);
      EL = Math.asin(TZS / DIST) * RTOD;
      RANGE = Math.max(DIST, DIST2);
      let jihua =
        Math.atan(
          Math.sin((ESLONG - SATLONG) * DTOR) / Math.tan(ESLAT * DTOR)
        ) * RTOD;
      this.jiaodu.fangwei = this.round(AZ, 3); //方位（保留小数点三位）
      this.jiaodu.fuyan = this.round(EL, 3); //俯仰角（保留小数点三位）
      this.jiaodu.jihua = this.round(jihua, 3); //极化（保留小数点三位）
      this.jiaodu.juli = this.round(RANGE, 3); //最大距离（保留小数点三位）
      this.background("success", "计算结果已生成到屏幕下方");
      //   console.log("地面站经度：" + String(ESLONG));
      //   console.log("卫星经度：" + String(SATLONG));
      //   console.log("地面站纬度：" + String(ESLAT));
      //   console.log(Math.sin((SATLONG - ESLONG) * DTOR));
      //   console.log(Math.tan(ESLAT * DTOR));
      //   console.log(Math.sin((ESLONG - SATLONG) * DTOR) - Math.tan(ESLAT * DTOR));
      //A＝arctg｛tg(ψs－ψg)/sinθ｝ 方位计算
      //
      //P = arctg[sin(ψs-ψg)/tgθ]  极化计算
      //tan() 正切
      //stan() 反正切
      //sin() 正弦
      // *DTOR 角度转弧度
      // *RTOD 弧度转角度
      //极化角度计算公式：P = 转角度(arctg(sin(转弧度(本地经度-卫星经度))/tan(转弧度(本地纬度))))
      //   console.log(
      //     "极化角度：" +
      //       Math.atan(
      //         Math.sin((ESLONG - SATLONG) * DTOR) / Math.tan(ESLAT * DTOR)
      //       ) *
      //         RTOD
      //   );
    },
    Check(obRef, def) {
      //设置默认值的函数，没什么用
      if (obRef.value == null || obRef.value == "" || obRef.value == "0") {
        obRef.value = def;
      }
    },
    ATAN2(x, y) {
      //数学函数
      var tmp;
      if (y == 0) {
        if (x > 0) {
          tmp = 0;
        } else {
          if (x < 0) {
            tmp = Math.PI;
          } else {
            tmp = 1 / 0;
          }
        }
      } else {
        if (y > 0) {
          tmp = Math.PI / 2 - Math.atan(x / y);
        } else {
          tmp = -(Math.PI / 2) - Math.atan(x / y);
        }
      }
      return tmp;
    },
    round(val, places) {
      //val保留places位小数点
      val = val * Math.pow(10, places);
      val = Math.round(val);
      val = val / Math.pow(10, places);
      return val;
    },
    // // 判断是否是 ios 设备
    // getIos() {
    //   var u = window.navigator.userAgent;
    //   return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // },
    // requestDeviceMotionIOS() {
    //   //请求设备运动IOS
    //   let that = this;
    //   if (typeof DeviceMotionEvent.requestPermission === "function") {
    //     DeviceMotionEvent.requestPermission()
    //       .then((permissionState) => {
    //         if (permissionState === "granted") {
    //           window.addEventListener("devicemotion", (event) => {
    //             let alpha = event.alpha,
    //               beta = event.beta,
    //               gamma = event.gamma;
    //             //console.log(Math.round(alpha),Math.round(beta), Math.round(gamma));
    //             // this.tuoluuoyi.fangwei = Math.round(alpha);
    //             // this.tuoluuoyi.fuyan = Math.round(beta);
    //             // this.tuoluuoyi.jihua = Math.round(gamma);
    //             that.tuoluuoyi.fangwei = Math.round(alpha);
    //             that.tuoluuoyi.fuyan = Math.round(beta);
    //             that.tuoluuoyi.jihua = Math.round(gamma);
    //           });
    //         } else {
    //           that.background("error", "你的浏览器不支持陀螺仪");
    //         }
    //       }, true)
    //       .catch((err) => {
    //         alert(JSON.stringify(err));
    //         alert("用户未允许权限");
    //       });
    //   } else {
    //     // 处理常规的非iOS 13+设备
    //     that.background("success", "处理常规的非iOS 13+设备");
    //     if (window.DeviceOrientationEvent) {
    //       window.addEventListener(
    //         "deviceorientation",
    //         function (event) {
    //           let alpha = event.alpha,
    //             beta = event.beta,
    //             gamma = event.gamma;
    //           that.tuoluuoyi.fangwei = Math.round(alpha);
    //           that.tuoluuoyi.fuyan = Math.round(beta);
    //           that.tuoluuoyi.jihua = Math.round(gamma);
    //         },
    //         true
    //       );
    //     } else {
    //       that.background("error", "你的浏览器不支持陀螺仪");
    //     }
    //   }
    // },

    // 请求设备定向权限
    requestDeviceOrientationIOS() {
      //请求设备定向IOS
      let that = this;
      if (typeof DeviceOrientationEvent.requestPermission === "function") {
        DeviceOrientationEvent.requestPermission()
          .then((permissionState) => {
            if (permissionState === "granted") {
              window.addEventListener("deviceorientation", (event) => {
                let alpha = event.alpha,
                  beta = event.beta,
                  gamma = event.gamma,
                  webkitCompassHeading = event.webkitCompassHeading;
                console.log(
                  Math.round(alpha),
                  Math.round(beta),
                  Math.round(gamma)
                );
                that.tuoluuoyi.fangwei = Math.round(webkitCompassHeading);
                that.tuoluuoyi.fuyan = Math.round(beta);
                that.tuoluuoyi.jihua = Math.round(-gamma);
              });
            } else {
              that.background("error", "你的浏览器不支持陀螺仪");
            }
          }, true)
          .catch((err) => {
            alert(JSON.stringify(err));
            alert("用户未允许权限");
          });
      } else {
        // 处理常规的非iOS 13+设备
        that.background("success", "处理常规的非iOS 13+设备");
        if (window.DeviceOrientationEvent) {
          window.addEventListener(
            "deviceorientation",
            function (event) {
              let alpha = event.alpha,
                beta = event.beta,
                gamma = event.gamma;

              console.log(
                Math.round(alpha),
                Math.round(beta),
                Math.round(gamma)
              );

              that.tuoluuoyi.fangwei = Math.round(360 - alpha);
              that.tuoluuoyi.fuyan = Math.round(beta);
              that.tuoluuoyi.jihua = Math.round(-gamma);
            },
            true
          );
        } else {
          that.background("error", "你的浏览器不支持陀螺仪");
        }
      }
    },
    gyroscope() {
      //this.background("success", this.getIos());
      //this.requestDeviceMotionIOS();
      this.requestDeviceOrientationIOS();

      //启动陀螺仪
      // this.background("success", "启动陀螺仪");
      // DeviceMotionEvent.requestPermission().then(function (state) {
      //     if ("granted" === state) {
      //       //this.background("success", "陀螺仪可用");
      //       window.addEventListener(
      //         "deviceorientation",
      //         function (event) {
      //           var alpha = event.alpha,
      //             beta = event.beta,
      //             gamma = event.gamma;
      //           //console.log(Math.round(alpha),Math.round(beta), Math.round(gamma));
      //           this.tuoluuoyi.fangwei = Math.round(alpha);
      //           this.tuoluuoyi.fuyan = Math.round(beta);
      //           this.tuoluuoyi.jihua = Math.round(gamma);
      //         },
      //         false
      //       );
      //     } else {
      //       this.background("error", "你的浏览器不支持陀螺仪");
      //     }
      //   })
      //   .catch(function (err) {
      //     alert("error: " + err);
      //   });
    },
  },
  mounted: function () {
    //生命周期钩子，实例被挂载后调用
    this.$nextTick(function () {
      //将回调延迟到下次 DOM 更新循环之后执行
      this.getLocation(); //获取用户位置
    });
  },
};
</script>

<style>
html,
body {
  background: url("../assets/bg.jpeg");
  background-size: cover;
  min-height: 100vh;
  text-align: center;
  height: 100%;
  width: 100%;
}
.weixing {
  background-color: rgba(255, 255, 255, 0);
  height: 100%;
  width: 100%;
}

.pbt {
  font-size: 25px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.custom .ivu-input {
  background-color: rgba(255, 255, 255, 0.3);
}
</style>